/**
 * Logo oficial do RESCUE-LAB (arquivos em `ativos/marca/`).
 *
 * Cada variante existe em duas versões: `-dark` (arte clara, para fundo
 * escuro) e `-light` (arte escura, para fundo claro). As duas são renderizadas
 * e o CSS mostra a certa: fundo escuro é o padrão e `.tema-claro` troca. Assim
 * o logo acerta o tema mesmo fora da barra (folha Sobre, tela de carregamento)
 * sem precisar receber o tema por prop.
 */
export type VarianteMarca = 'horizontal' | 'logo' | 'icon'

interface Props {
  variante: VarianteMarca
  className?: string
}

export function MarcaRescueLab({ variante, className }: Props) {
  const base = `/marca/rescue-lab-${variante}`
  const classes = ['marca-rescue-lab', `marca-rescue-lab--${variante}`, className]
    .filter(Boolean)
    .join(' ')

  return (
    <span className={classes}>
      <img src={`${base}-dark.svg`} alt="RESCUE LAB" className="marca-rescue-lab__fundo-escuro" />
      <img src={`${base}-light.svg`} alt="RESCUE LAB" className="marca-rescue-lab__fundo-claro" />
    </span>
  )
}
